// extracted by mini-css-extract-plugin
module.exports = {"card-header":"OrderHistory_card-header__18OBD","card-content":"OrderHistory_card-content__3SOTo","orders":"OrderHistory_orders__1G-MC"};